// Magic Afro — wishlist-heart click guard.
//
// Product-card images are wrapped in the product link (a.contents -> product
// page), and the whole image is now tappable. The WishlistHero heart is
// injected (client-side) on top of the card image, so a tap on the heart would
// bubble to the product link and OPEN the product instead of just adding to the
// wishlist. This guard stops that: when a wishlist heart that sits INSIDE a link
// is clicked, the link's navigation is prevented (preventDefault only — we do
// NOT stopPropagation, so the wishlist app's own click handler still runs and
// adds the product). The header "Ma liste de souhaits" link (which IS the link,
// not nested in one) is unaffected.
(function () {
  if (window.__magicWishlistGuard) return;
  window.__magicWishlistGuard = true;

  var HEART_SELECTOR = [
    '.wishlist-hero-custom-button',
    '[class*="wishlisthero"]',
    '[data-wlh-id]',
    '[data-wlh-link]',
    'button[aria-label*="souhait" i]',
    'button[aria-label*="wishlist" i]',
    'button[aria-label*="favori" i]'
  ].join(', ');

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var heart = t.closest(HEART_SELECTOR);
      if (!heart) return;
      var link = heart.closest('a[href]');
      // Block only when the heart is nested inside a link — never when the heart
      // itself is the link (header wishlist link returns itself from closest()).
      if (link && link !== heart) {
        e.preventDefault();
      }
    },
    true // capture phase: run before the link's default navigation
  );
})();
